module.exports = __webpack_public_path__ + "static/media/social-rediit.b1bd23b7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/avatars/social-rediit.svg
// module id = 123
// module chunks = 0